<template>
  <div class="d-flex">
    <b-container fluid class="p-0">
      <b-row no-gutters>
        <b-col :cols="has_extra_value ? 4 : 6" class="pr-3">
          <v-select
            :label="$t('attribute')"
            v-model="rule.id"
            :items="options"
            item-text="text"
            item-value="index"
            dense
            outlined
          />
        </b-col>
        <b-col :cols="has_extra_value ? 4 : 6" class="pr-3">
          <v-text-field
            v-if="selectedOption.type == 'text'"
            v-model="rule.value"
            :label="opLabel"
            dense
            outlined
            :error-messages="valueErrors"
            @blur="$v.rule.value.$touch()"
          />
          <v-select
            v-else-if="selectedOption.type === 'dropdown'"
            v-model="rule.value"
            :label="opLabel"
            :items="ruleOperatorOptions"
            item-text="text"
            item-value="index"
            dense
            outlined
            :error-messages="valueErrors"
            @blur="$v.rule.value.$touch()"
          />
          <div v-else-if="selectedOption.type === 'files'">
            <!-- VFileInput only gets real File objects -->
            <v-file-input
              :value="newFiles"
              :label="opLabel"
              dense
              outlined
              multiple
              chips
              :error-messages="valueErrors"
              @blur="$v.rule.value.$touch()"
              @change="onFileChange"
            />
            <div
              v-if="existingFiles?.length"
              class="mb-2 d-flex flex-wrap ps-7"
            >
              <v-chip
                v-for="(file, index) in existingFiles"
                :key="'existing-' + index"
                close
                small
                class="mb-1"
                @click:close="removeExistingFile(index)"
              >
                <a :href="file.url" target="_blank">
                  <v-icon small left>mdi-file</v-icon>
                  {{ file.name }}
                </a>
              </v-chip>
            </div>
          </div>
          <!--          <v-file-input-->
          <!--            v-else-if="selectedOption.type === 'files'"-->
          <!--            v-model="rule.value"-->
          <!--            :label="opLabel"-->
          <!--            :items="ruleOperatorOptions"-->
          <!--            dense-->
          <!--            outlined-->
          <!--            multiple-->
          <!--            chips-->
          <!--            :error-messages="valueErrors"-->
          <!--            @blur="$v.rule.value.$touch()"-->
          <!--          />-->
        </b-col>
        <b-col cols="4" class="pr-3" v-if="has_extra_value">
          <v-text-field
            v-model="rule.extra_data"
            :label="$t('value')"
            dense
            outlined
            clearable
            :error-messages="extra_dataErrors"
            @blur="$v.rule.extra_data.$touch()"
          />
        </b-col>
      </b-row>
    </b-container>
    <div class="max-h-65">
      <button
        class="h-40px w-40px btn btn-sm btn-icon btn-light-info btn-hover-light"
        @click="deleteRule"
      >
        <span class="svg-icon">
          <v-icon size="18">mdi-delete</v-icon>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { SET_ACTION_NOT_VALID } from "@/core/services/store/shipmentCreationRules.module";

export default {
  name: "Action",
  mixins: [validationMixin],
  validations() {
    return {
      rule: {
        value: { required },
        extra_data: {
          required: requiredIf(function () {
            return !!this.has_extra_value;
          }),
        },
      },
    };
  },
  props: {
    rule: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
    },
    userId: {
      required: false,
    },
    operators: {
      required: true,
      type: Object,
    },
    actions: {
      required: true,
      type: Array,
    },
    updateValues: {
      required: true,
      type: Function,
    },
  },
  mounted() {
    this.updateValuesList();
  },
  data: () => ({ values: null }),
  computed: {
    existingFiles() {
      // console.log("this.rule", this.rule);
      // console.log("this.rule.value", this.rule.value);

      if (!this.rule.value) return [];
      const arr = Array.isArray(this.rule.value)
        ? this.rule.value
        : [this.rule.value];

      return arr.filter((v) => v?.isExisting);
    },

    newFiles() {
      if (!this.rule.value) return [];
      const arr = Array.isArray(this.rule.value)
        ? this.rule.value
        : [this.rule.value];
      // Only real File objects go to VFileInput
      return arr.filter((v) => v instanceof File);
    },
    selectedOption() {
      return this.options.find((option) => option.index === this.rule.id);
    },
    currentRuleID: function () {
      return this.rule.id;
    },
    ruleOperatorOptions: function () {
      return this.values;
    },
    opLabel() {
      return this.options.find((option) => option.index === this.rule.id).text;
    },
    has_extra_value() {
      return (
        this.options.find((option) => option.index === this.rule.id)
          ?.has_extra_value === 1
      );
    },
    valueErrors: function () {
      return this.handleFormValidation("value", this, "rule");
    },
    extra_dataErrors: function () {
      return this.handleFormValidation("extra_data", this, "rule");
    },
  },
  methods: {
    onFileChange(files) {
      // Merge existing URLs + newly picked files
      const merged = [...this.existingFiles, ...(files || [])];
      this.rule.value = merged.length ? merged : null;
    },

    removeExistingFile(index) {
      const updatedExisting = this.existingFiles.filter((_, i) => i !== index);
      const merged = [...updatedExisting, ...this.newFiles];
      this.rule.value = merged.length ? merged : null;
    },
    updateValuesList() {
      if (this.currentRuleID == 2) {
        let carrier_id = this.actions.find((action) => action.id == 1)?.value;
        if (carrier_id != undefined && carrier_id != null) {
          this.values = this.operators[
            `${
              this.options.find((option) => option.index === this.rule.id)
                .key_name
            }`
          ].filter((operator) => operator.carrier_id == carrier_id);
        } else {
          this.values =
            this.operators[
              `${
                this.options.find((option) => option.index === this.rule.id)
                  .key_name
              }`
            ];
        }
      } else {
        this.values =
          this.operators[
            `${
              this.options.find((option) => option.index === this.rule.id)
                .key_name
            }`
          ];
      }
    },
    handleFormValidation(fieldName, vueObj, dataName = "formData") {
      const errors = [];
      if (!vueObj.$v[`${dataName}`][fieldName]?.$dirty) return errors;
      if ("required" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      if ("maxValue" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].maxValue &&
          errors.push("This field must be greater than 0");
      }
      if ("url" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].url &&
          errors.push(this.$t("validation_this_url_is_invalid"));
      }
      if ("numeric" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].numeric &&
          errors.push(this.$t("validation_this_must_be_a_number"));
      }
      if ("email" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].email &&
          errors.push(this.$t("validation_this_email_address_is_invalid"));
      }
      return errors;
    },
    deleteRule: function () {
      const self = this;
      const parentRules = self.$parent.currentQuery;
      parentRules.splice(parentRules.indexOf(self.rule), 1);
      this.$nextTick(() => {
        this.updateValues();
      });
    },
  },
  watch: {
    currentRuleID: function () {
      this.rule.value = null;
    },
    rule: {
      handler() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$store.commit(SET_ACTION_NOT_VALID, true);
        } else {
          this.$store.commit(SET_ACTION_NOT_VALID, false);
        }
      },
      deep: true,
    },
  },
};
</script>
